import { IBucketProduct } from 'featureSliced/shared/store/reducers/QRMenuBucketReducer/types'

/** surcharge of the chosen components, per menu */
export const menuExtrasPerUnit = (line: Pick<IBucketProduct, 'menuItems'>) =>
  Array.isArray(line.menuItems)
    ? line.menuItems.reduce(
        (sum, component) =>
          sum + (Number(component.count) || 0) * (Number(component.price) || 0),
        0
      )
    : 0

/** what one cart line costs: (head + its components) × count */
export const cartLineTotal = (
  line: Pick<IBucketProduct, 'menuItems' | 'count'>,
  unitPrice: number
) => (unitPrice + menuExtrasPerUnit(line)) * (Number(line.count) || 0)
